import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { UserCreatePayload } from '../models/user-create-model';
import { CustomerCreateModel } from '../models/customer-create-model';
import { CustomerServiceCreateModel } from '../models/customer-service-create-model';
import { TransactionCreatePayload } from '../models/transaction-create-model';
import { TransactionListFilterPayload } from '../models/transaction-list-model';
import { MetaDataModel } from '../models/transaction-metadata-model';
import { QuotationMetaDataModel } from '../models/transaction-quotation-model';

@Injectable({
  providedIn: 'root',
})
export class TransactionMasterService {
  constructor(private http: HttpClient) {}

  lFN_GetUnitList() {
    return this.http.get(`${environment.ROOT_URL}/unit-master`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_SaveTransaction(payload: TransactionCreatePayload) {
    return this.http.post(
      `${environment.ROOT_URL}/transaction/create`,
      payload,
      {
        withCredentials: false,
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  lFN_UpdateTransactionById(transactionId: number, payload: TransactionCreatePayload) {
    return this.http.put(
      `${environment.ROOT_URL}/transaction/edit/transaction-id/${transactionId}`,
      payload,
      {
        withCredentials: false,
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  lFN_GetTransactionListFilter(payload: Partial<TransactionListFilterPayload>) {
    return this.http.post(
      `${environment.ROOT_URL}/transaction/transactions`,
      payload,
      {
        withCredentials: false,
        responseType: 'text',
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  lFN_GetTransactionById(transactionId: number) {
    return this.http.get(
      `${environment.ROOT_URL}/transaction/transaction-id/${transactionId}`,
      {
        withCredentials: false,
        responseType: 'text',
        observe: 'response',
      }
    );
  }

  lFN_ToggleActive(transactionId: number, isActive: string) {
    const url = `${environment.ROOT_URL}/transaction/toggle/transaction-id/${transactionId}/flag`;

    return this.http.patch(url, null, {
      params: new HttpParams().set('isActive', isActive),
      observe: 'response',
    });
  }

  lFN_GenerateInvoice(transactionId: number, payload: MetaDataModel) {
    return this.http.post(
      `${environment.ROOT_URL}/print/report/invoice/${transactionId}`,
      payload,
      {
        withCredentials: false,
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

    lFN_GenerateQuotation(transactionId: number, payload: QuotationMetaDataModel) {
    return this.http.post(
      `${environment.ROOT_URL}/print/report/quotation/${transactionId}`,
      payload,
      {
        withCredentials: false,
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

    lFN_CancelTransactionById(transactionId: number) {
    return this.http.patch(
      `${environment.ROOT_URL}/transaction/cancel/transaction-id/${transactionId}`,
      {
        withCredentials: false,
        responseType: 'text',
        observe: 'response',
      }
    );
  }
}
